import { GenericLazyString, gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { ColorTheme } from '../../constants/colorThemes';
import './CategoryBrowseHeader.scss';
import { CategoryBrowseStickyHeader } from './CategoryBrowseStickyHeader';

export interface CategoryBrowseHeaderProps {
    title: string | GenericLazyString | React.ReactElement;
    subtitle: string | GenericLazyString;
    imageUrl?: string;
    fallbackTitle?: string | GenericLazyString;
    fallbackImage?: string;
    breadCrumb?: React.ReactElement;
    callToAction?: React.ReactElement;
    isRounded: boolean;
    theme: ColorTheme;
}

export const CategoryBrowseHeader = (props: CategoryBrowseHeaderProps) => {
    const {
        fallbackTitle,
        title,
        subtitle,
        imageUrl,
        fallbackImage,
        callToAction,
        isRounded,
        theme,
    } = props;

    const imageClasses = classNames('category-browse--header-image', {
        'category-browse--header-image--rounded': isRounded,
        'category-browse--header-image--square': !isRounded,
    });

    return (
        <>
            <div
                className="category-browse--header-container"
                style={{ backgroundColor: theme.background }}
            >
                <div className="category-browse--header">
                    <div className="category-browse--header-text">
                        <div className="category-browse--header-text__wrapper">
                            <h1
                                className="category-browse__header--content"
                                style={{ color: theme.primary }}
                            >
                                {title || fallbackTitle}
                            </h1>
                            <p style={{ color: theme.secondary }}>{subtitle}</p>
                            {callToAction}
                        </div>
                    </div>
                    <aside className={imageClasses}>
                        <img
                            //HTML Img Definition doesnt support fetchpriority but it
                            //is supported in chrome and edge with broader support coming
                            //https://caniuse.com/mdn-html_elements_img_fetchpriority
                            //eslint-disable-next-line
                            //@ts-ignore
                            fetchpriority="high"
                            className="full-width-img"
                            loading="eager"
                            src={imageUrl || fallbackImage}
                            alt={
                                title?.toString() ||
                                gettext('Category browse').toString()
                            }
                        />
                    </aside>
                </div>
            </div>
            <CategoryBrowseStickyHeader title={fallbackTitle} />
        </>
    );
};
